import React, {useContext} from "react";
import { PopupContext } from "../../index";
import { debug } from "../../utils";
import { connect } from "react-redux";
import * as modalDataService from "./modalDataService";
import { getConfirmPopup } from "../../view/popup/PopupContainer";

function EnableSystemRemediationField({ enableRemediation }) {

    const { setPopup } = useContext(PopupContext);

    const onChange = (value) => {

        if (value) {
             const onConfirm = () => {modalDataService.changeEnableSystemRemediation(value);}

            setPopup(
                getConfirmPopup('Caution! Enabling this setting will trigger remediation for all failed rules, which may impose impacts.',
                    'System Remediation',
                    () => onConfirm()
                )
            ); 
        } else {
            modalDataService.changeEnableSystemRemediation(value);
        }
            
    
    }

    return (
        <div className="form-group">
            <div className="oct_check oct_check-v2 oct_check-v2-remediation">
                <label className="oct_check-label oct_check-label-v2 oct_check-label-v2-remediation">
                    <input type="checkbox" checked={!!enableRemediation} onChange={() => {
                        //setShow(!showPasswordTextField); 
                        onChange(!enableRemediation);
                    }} />
                    <span className="oct_check-copy-v2 oct_check-copy-v2-remediation">
                        <span className="oct_check-title-v2">Enable Automatic System Remediation</span>
                        <span className="oct_check-help-v2">Automatically apply security fixes and compliance updates when violations are detected</span>
                    </span>
                </label>
            </div>
        </div>
    )

}

function mapStateToProps(state) {
    debug("EnablePasswordField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    return {
        enableRemediation: addDeviceModal.enableRemediation || ''
    }
}

export default connect(mapStateToProps)(EnableSystemRemediationField);
